export const getRandomValue = (): string => {
  try {
    // pretty decent browser support for crypto, but just in case it fails
    // we can fallback to a generic version using Math.random that will produce
    // a "random enough" value
    return window.crypto.getRandomValues(new Uint8Array(4)).join('');
  } catch {
    return Math.random().toString(36).substring(2, 5);
  }
};
